document.addEventListener('DOMContentLoaded', function () {
  const isGerman = window.location.hostname.includes("malen-nach-zahlen");

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.tax-info').forEach(el => {
      const expected = isGerman
        ? "inkl. Mwst. zzgl. Versand"
        : "excl. VAT excl. Shipping";

      if (el.textContent.trim() !== expected) {
        el.textContent = expected;
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
